import { canvasToBlob } from "./artworkCodec";
import { renderComicDocument } from "../comic/ComicRenderer";
import type { PersistedDocumentState } from "../comic/comicTypes";

export const THUMBNAIL_MAX_DIMENSION = 320;

export async function createThumbnailBlob(
  source: HTMLCanvasElement,
  documentState?: PersistedDocumentState,
): Promise<Blob> {
  const scale = Math.min(1, THUMBNAIL_MAX_DIMENSION / Math.max(source.width, source.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(source.width * scale));
  canvas.height = Math.max(1, Math.round(source.height * scale));
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas 2D is unavailable for thumbnail generation.");

  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";
  context.drawImage(source, 0, 0, canvas.width, canvas.height);
  if (documentState?.comicTemplateId) {
    context.save();
    context.scale(scale, scale);
    renderComicDocument(context, documentState, source.width, source.height);
    context.restore();
  }

  try {
    try {
      const webp = await canvasToBlob(canvas, "image/webp", 0.82);
      if (webp.type === "image/webp") return webp;
    } catch {
      // PNG below is the broadly supported lossless fallback.
    }
    return await canvasToBlob(canvas, "image/png");
  } finally {
    canvas.width = 1;
    canvas.height = 1;
  }
}
